import API from '@/lib/API';

const RESOURCE_URL = '/tasks';

export const taskService = {
  /**
   * Create a new project task
   * @param {Object} taskData 
   */
  createTask: async (taskData) => {
    try {
      const response = await API.post(RESOURCE_URL, taskData);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Update an existing project task
   * @param {string} taskId
   * @param {Object} taskData
   */
  updateTask: async (taskId, taskData) => {
    try {
      const response = await API.put(`${RESOURCE_URL}/${taskId}`, taskData);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Get all tasks for a project
   * @param {string} projectId 
   */
  getProjectTasks: async (projectId) => {
    try {
      const response = await API.get(`${RESOURCE_URL}/project/${projectId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Get field officers for assignment dropdown
   */
  getFieldOfficers: async () => {
    try {
      const response = await API.get(`${RESOURCE_URL}/field-officers`);
      return response?.data?.data || response?.data || response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /**
   * Update task status or progress
   * @param {string} id 
   * @param {Object} data 
   */
  updateTaskStatus: async (id, data) => {
    try {
      const response = await API.patch(`${RESOURCE_URL}/${id}/status`, data);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  /** Installation member site work update (drives project pipeline). */
  postWorkUpdate: async (taskId, data) => {
    try {
      const response = await API.post(`${RESOURCE_URL}/${taskId}/work-update`, data);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};
